import { Link, useLocation } from 'react-router-dom';
import { Palette, ShoppingBag, Menu, X } from 'lucide-react';
import { useState } from 'react';
import { useCart } from '@/context/CartContext';

export const OriginalsNav = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { getItemCount } = useCart();
  const itemCount = getItemCount();
  
  const navLinks = [
    { path: '/originals', label: 'Gallery' },
    { path: '/originals/about', label: 'About' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/90 backdrop-blur-md border-b border-[#27272a]" data-testid="originals-nav">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-4" data-testid="originals-logo">
            <div className="w-12 h-12 rounded-full border border-[#d4af37] flex items-center justify-center">
              <Palette className="w-6 h-6 text-[#d4af37]" />
            </div>
            <div className="hidden sm:block">
              <span className="font-playfair text-xl text-white">Ben Jefferies</span>
              <span className="font-cinzel text-xs text-[#d4af37] block tracking-widest">ORIGINALS</span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-cormorant text-lg transition-colors ${
                  isActive(link.path)
                    ? 'text-[#d4af37]'
                    : 'text-[#a1a1aa] hover:text-white'
                }`}
                data-testid={`nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </Link>
            ))}
            
            {/* Cart */}
            <Link 
              to="/originals/cart" 
              className="relative p-2 hover:text-[#d4af37] transition-colors"
              data-testid="cart-link"
            >
              <ShoppingBag className="w-6 h-6" />
              {itemCount > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#d4af37] text-black text-xs font-bold rounded-full flex items-center justify-center">
                  {itemCount}
                </span>
              )}
            </Link>

            {/* Back to Main */}
            <Link 
              to="/" 
              className="text-sm text-[#a1a1aa] hover:text-[#d4af37] font-cormorant transition-colors"
              data-testid="back-to-main-originals"
            >
              ← Main Site
            </Link>
          </div>

          {/* Mobile: Cart + Menu */}
          <div className="md:hidden flex items-center gap-4">
            <Link to="/originals/cart" className="relative p-2" data-testid="mobile-cart-link">
              <ShoppingBag className="w-6 h-6" />
              {itemCount > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#d4af37] text-black text-xs font-bold rounded-full flex items-center justify-center">
                  {itemCount}
                </span>
              )}
            </Link>
            <button 
              className="p-2"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="originals-mobile-menu-toggle"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-6 border-t border-[#27272a]">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-3 font-cormorant text-lg ${
                  isActive(link.path) ? 'text-[#d4af37]' : 'text-[#a1a1aa]'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Link 
              to="/" 
              className="block py-3 text-[#a1a1aa] font-cormorant border-t border-[#27272a] mt-4"
              onClick={() => setMobileMenuOpen(false)}
            >
              ← Back to Main Site
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};
